module.exports = __webpack_public_path__ + "img/21.ccf209e7.png";